import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";
import {
  BOTTOM_PANEL_INSET_VAR,
  COMPACT_FAB_STACK_STEP,
  COMPACT_FLOATING_BUTTON_SIZE,
  FAB_BOTTOM,
  FAB_STACK_STEP,
} from "@rentablo/components";
import AiIcon from "@icons/myicons/ai.svg?react";

// Sits in line with the FeedbackButton FAB, one step to its left, sharing the
// dock's bottom offset; both rise above the settings bar via the
// --bottom-panel-inset CSS var.
const FabStyled = styled(Box)`
  position: fixed;
  bottom: calc(var(${BOTTOM_PANEL_INSET_VAR}, 0px) + ${FAB_BOTTOM}px);
  right: calc(${({ theme }) => theme.spacing(2)} + ${FAB_STACK_STEP}px);
  z-index: ${({ theme }) => theme.zIndex.appBar};

  ${({ theme }) => theme.breakpoints.down("sm")} {
    right: calc(
      ${({ theme }) => theme.spacing(2)} + ${COMPACT_FAB_STACK_STEP}px
    );
  }
`;

const ButtonStyled = styled(Button)`
  border-radius: 50%;
  height: 50px;
  min-width: 50px;
  width: 50px;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    height: ${COMPACT_FLOATING_BUTTON_SIZE}px;
    min-width: ${COMPACT_FLOATING_BUTTON_SIZE}px;
    width: ${COMPACT_FLOATING_BUTTON_SIZE}px;
    /* The button's side padding would leave the icon 8px. */
    padding: 0;

    svg {
      flex: none;
      width: 26px;
      height: 26px;
    }
  }
`;

export const AiButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <FabStyled>
      <ButtonStyled variant="contained" color="gradient" onClick={onClick}>
        <AiIcon width="30px" height="30px" />
      </ButtonStyled>
    </FabStyled>
  );
};
